import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';
import type { WModuleGroupView, WModuleView } from '@zola/svc-web-api-ts-client';
import _find from 'lodash/find';

import mapNavConstantsToModuleGroup from './mapNavConstantsToModuleGroup';

const mapNavTypeToModule = (
  moduleGroups: WModuleGroupView[] = [],
  activeNavType: PrimaryNavIdentifier,
  size = ''
): WModuleView[] => {
  const module =
    _find(moduleGroups, ({ tag }) => tag === mapNavConstantsToModuleGroup(activeNavType, size)) ||
    {};
  return module.moduleViews || [];
};

export default mapNavTypeToModule;
